import { useId } from 'react';
import styled, { keyframes } from 'styled-components';

import { DiamondBaseColor } from '#src/components/series/SeriesBoard/HotStreakTile/Tile/utils.ts';

const glowing = keyframes`
  0% {
    transform: scale(0.9) translate(-50%, -50%);
    opacity: 0;
  }
  50% {
    transform: scale(1.2) translate(-50%, -50%);
    opacity: 1;
  }
  100% {
    transform: scale(1.3) translate(-50%, -50%);
    opacity: -3;
  }
`;

const Glow = styled.div`
  transform-origin: top left;
  filter: blur(2px) saturate(1);
  animation: ${glowing} 4s ease-in-out infinite;
`;

type Props = { color: DiamondBaseColor; animated?: boolean; size?: number };
export const DiamondBorder = ({ color, animated, size = 1 }: Props) => {
  const orangeGradientId = useId();
  const greenGradientId = useId();
  const redGradientId = useId();
  const blueGradientId = useId();

  const filterId = useId();

  const gradientId = {
    [DiamondBaseColor.orange]: orangeGradientId,
    [DiamondBaseColor.green]: greenGradientId,
    [DiamondBaseColor.red]: redGradientId,
    [DiamondBaseColor.blue]: blueGradientId,
  }[color];

  const svg = (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      style={{ width: size * 118, height: size * 78 }}
      viewBox="0 0 118 78"
      fill="none"
    >
      <g style={{ mixBlendMode: 'plus-lighter' }} filter={`url(#${filterId})`}>
        <path
          d="M58.8103 16.1724L97.3103 38.1724L98.0701 38.6069L97.3103 39.0415L58.8103 61.0415L58.5623 61.1831L58.3142 61.0415L19.8142 39.0415L19.0544 38.6069L19.8142 38.1724L58.3142 16.1724L58.5623 16.0308L58.8103 16.1724Z"
          stroke={`url(#${gradientId})`}
        />
      </g>
      <g
        style={{ mixBlendMode: 'plus-lighter' }}
        filter="url(#filter1_f_10778_10083)"
      >
        <path
          d="M59.5544 14.8706L98.0544 36.8706L101.094 38.6069L98.0544 40.3433L59.5544 62.3433L58.5623 62.9106L57.5701 62.3433L19.0701 40.3433L16.031 38.6069L19.0701 36.8706L57.5701 14.8706L58.5623 14.3032L59.5544 14.8706Z"
          stroke="url(#paint1_radial_10778_10083)"
          strokeWidth="4"
        />
      </g>
      <defs>
        <filter
          id={filterId}
          x="17.0466"
          y="14.4551"
          width="83.0312"
          height="48.3037"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="0.5"
            result="effect1_foregroundBlur_10778_10083"
          />
        </filter>
        <filter
          id="filter1_f_10778_10083"
          x="0"
          y="0"
          width="117.125"
          height="77.2139"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="6"
            result="effect1_foregroundBlur_10778_10083"
          />
        </filter>
        <radialGradient
          id={orangeGradientId}
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(57.59 46.3511) scale(39.4722 55.4839)"
        >
          <stop stopColor="#FEF314" />
          <stop offset="1" stopColor="#FF4E22" />
        </radialGradient>
        <radialGradient
          id={greenGradientId}
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(57.59 46.3511) scale(39.4722 55.4839)"
        >
          <stop stopColor="#00F34D" />
          <stop offset="1" stopColor="#00D5FF" />
        </radialGradient>
        <radialGradient
          id={redGradientId}
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(55.1637 46.3511) scale(36.9201 55.4839)"
        >
          <stop stopColor="#721717" />
          <stop offset="1" stopColor="#D81616" />
        </radialGradient>
        <radialGradient
          id={blueGradientId}
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(57.59 46.3511) scale(39.4722 55.4839)"
        >
          <stop stopColor="#1B034B" />
          <stop offset="1" stopColor="#7029FF" />
        </radialGradient>
      </defs>
    </svg>
  );

  return (
    <>
      {svg}
      {!!animated && <Glow>{svg}</Glow>}
    </>
  );
};
